import React from 'react';
import ContactHero from './ContactHero';
import ContactSection from './ContactSection';

const ContactPage = () => {
	return (
		<div>
			<ContactHero />
			<ContactSection />
		</div>
	);
};

export default ContactPage;
